import { useQuery } from "@tanstack/react-query";
import { useSessionScope } from "@/auth/use-session-scope";
import { useCompanyAxis } from "@/api/use-company-context";
import { platformGraph } from "@/api/platform-graph";
import { unwrapEnvelope } from "@/api/errors";
export const canOpenDocumentRequestManagement = (data: {can_manage: boolean} | undefined) => data?.can_manage === true;
export function useDocumentRequestAccess({enabled = true}: {enabled?: boolean} = {}) {
  const scope = useSessionScope(); const company = useCompanyAxis();
  return useQuery({queryKey: ["document-requests", ...scope, "capabilities", company.active_legal_entity_id], queryFn: () => unwrapEnvelope(platformGraph.GET("/v1/document-requests/capabilities")), enabled, staleTime: 30_000});
}
